import request from '@/utils/request'

export const getCustomerList = (params: any) =>
  request({
    url: '/customer/page',
    method: 'get',
    params
  })

export const rechargeCustomer = (data: any) =>
  request({
    url: '/customer/recharge',
    method: 'post',
    data
  })
